import { connect } from 'react-redux';
import { requestPasswordReset } from '../actions';
import ForgotPassword from './ForgotPassword';
var mapStateToProps = function mapStateToProps(_ref) {
  var authentication = _ref.authentication;
  return {
    status: authentication.status
  };
};
export default connect(mapStateToProps, {
  requestPasswordReset: requestPasswordReset
})(ForgotPassword);